import cloneDeep from 'lodash.clonedeep';

const getAppConfig = () => {
  return cloneDeep(window.appConfig) || {};
};

export default getAppConfig();